var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEFF1",
    d: "M15.5 13h-7c-.276 0-.5-.224-.5-.5v-10a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#388E3C",
    d: "M10.5 5h-2a.5.5 0 010-1h2a.5.5 0 010 1zM10.5 7h-2a.5.5 0 010-1h2a.5.5 0 010 1zM10.5 9h-2a.5.5 0 010-1h2a.5.5 0 010 1zM10.5 11h-2a.5.5 0 010-1h2a.5.5 0 010 1zM13.5 5h-1a.5.5 0 010-1h1a.5.5 0 010 1zM13.5 7h-1a.5.5 0 010-1h1a.5.5 0 010 1zM13.5 9h-1a.5.5 0 010-1h1a.5.5 0 010 1zM13.5 11h-1a.5.5 0 010-1h1a.5.5 0 010 1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E7D32",
    d: "M8.819.115a.491.491 0 0 0-.411-.106l-8 1.5A.499.499 0 0 0 0 2v11a.5.5 0 0 0 .408.491l8 1.5A.498.498 0 0 0 9 14.5V.5a.499.499 0 0 0-.181-.385z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M6.876 9.171L5.295 7.364l1.599-2.056a.5.5 0 0 0-.789-.615L4.624 6.597 3.376 5.171a.5.5 0 1 0-.752.658l1.375 1.572-1.394 1.792a.5.5 0 1 0 .79.614l1.275-1.64 1.454 1.661a.496.496 0 0 0 .705.048.5.5 0 0 0 .047-.705z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excel-icon.fedf9b38330f5ff0544bad4a596c2dfd.svg";
export { ForwardRef as ReactComponent };